import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

import { UpdateQuestionInput } from '../question.types';

export interface UpdateEventQuestionnaireQuestionInput {
  eventId: number;
  question: UpdateQuestionInput;
}

export interface UpdateEventQuestionnaireQuestionResult {
  updateEventQuestionnaireQuestion: {
    ok: boolean;
  };
}

const UpdateEventQuestionnaireQuestionMutation = gql`
  mutation updateEventQuestionnaireQuestion($input: UpdateEventQuestionnaireQuestionInput!) {
    updateEventQuestionnaireQuestion(input: $input) {
      ok
    }
  }
`;

export const updateEventQuestionnaireQuestion = (
  input: UpdateEventQuestionnaireQuestionInput
): Promise<UpdateEventQuestionnaireQuestionResult> => {
  return gqlClient.request<UpdateEventQuestionnaireQuestionResult>(
    UpdateEventQuestionnaireQuestionMutation,
    {
      input
    }
  );
};
